export default (state) => state.restricted._session.all_session_ids;
